module.exports = __webpack_public_path__ + "static/media/avatar_example.55f73784.png";